export const MEMBER = 'member';
export const MOBILE_BARCODE = 'mobile-barcode';
export const DIGITAL_CERTIFICATE = 'digital-certificate';
